import { render, staticRenderFns } from "./billType.vue?vue&type=template&id=ca12fb34&scoped=true&"
import script from "./billType.vue?vue&type=script&lang=js&"
export * from "./billType.vue?vue&type=script&lang=js&"
import style0 from "./billType.vue?vue&type=style&index=0&id=ca12fb34&scoped=true&lang=css&"
import style1 from "./billType.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca12fb34",
  null
  
)

export default component.exports